import { gql } from "@apollo/client";

const GETUSERACTIVECHATCOUNTS = gql`
  query getUserActiveChatCount($agentId: [ID], $timeFrame: String) {
    getUserActiveChatCount(agentId: $agentId, timeFrame: $timeFrame) {
      success
      error
      count
    }
  }
`;

export default GETUSERACTIVECHATCOUNTS;
